<template>
    <div class="manage-module">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <!-- 区域分布 -->
            <div class="box pb-50" v-show="checkedStore.id == -1">
                <div class="font34 Blacks mb-30 bold">{{ chartData.title }}</div>
                <div class="txt txt-line">{{ chartData.deadline }}</div>
                <div class="unit">单位：万元</div>
                <div class="nursingchart">
                    <div ref="nursingchart" id="nursingchart"></div>
                </div>
                <div class="add-up-box flex">
                    <div class="tit">销售金额累计：<span class="num">{{ chartData.saleTotal }}</span></div>
                    <div class="tit">消费金额累计：<span class="num">{{ chartData.netTotal }}</span></div>
                </div>
            </div>
            <div class="cut-line" v-if="checkedStore.id == -1"></div>
            <!-- 门店分布 -->
            <div :class="`box ${checkedStore.id == -1 ? 'pt-50' : ''}`">
                <div class="font34 Blacks mb-30 bold">{{ storeData.title }}</div>
                <div class="txt txt-line">{{ storeData.deadline }}</div>
                <div class="unit">单位：万元</div>
                <div class="nursingchart">
                    <div ref="storechart" id="storechart"></div>
                </div>
                <div class="add-up-box flex">
                    <div class="tit">销售金额累计：<span class="num">{{ storeData.saleTotal }}</span></div>
                    <div class="tit">消费金额累计：<span class="num">{{ storeData.netTotal }}</span></div>
                </div>
            </div>
            <div class="cut-line" v-if="checkedStore.id == -1 || checkedStore.id == 0"></div>
            <div class="empty-box" v-if="checkedStore.id == -1 || checkedStore.id == 0">
                <div class="flex-col flex-y-center">
                    <img class="empty-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/empty.png" alt="">
                    <div class="empty-txt">客户详细数据请切换至单门店查看</div>
                </div>
            </div>
        </van-pull-refresh>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
    </div>
</template>
<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { getCookie } from '@/utils'
    import { mapState } from 'vuex'
    import Picker from '@/components/Picker';
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'


    export default {
        name: "emphasisNursingItem",
        inject: ['reload'],
        components: {
            Picker
        },
        data() {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                page: 1,
                customerList: [],//列表
                searchStr: '',// 搜索
                chartData: {},// 图表数据
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                storeData: {},  // 门店数据
                nursingchart: null,
                storechart: null,
                changeId: ''
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
            });

            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                }
                this.initExclusiveChart()
                this.initStoreChart()
                this.getCustList()
            })
        },
        methods: {
            //柱状图加载
            async initExclusiveChart() {
                const _this = this
                this.getChartData().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    var yAxisData = this.chartData.regionY;
                    let myEcharts = this.$echarts.init(this.$refs.nursingchart);
                    window.onresize = myEcharts.resize;
                    let options = {
                        grid: {
                            top: "15",
                            left: "15",
                            bottom: "50",
                            right: "7%",
                            containLabel: true,
                        },
                        legend: [
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#085AFF', fontSize: '14' },
                                data: [{ name: '销售金额', }],   //rect为矩形
                                bottom: '1%',
                                right: '56%'
                            },
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#2FD0D5', fontSize: '14' },
                                data: [{ name: '消费金额', }],   //rect为矩形
                                bottom: '1%',
                                right: '25%',
                            },

                        ],
                        tooltip: {
                            borderColor: 'transparent',
                            formatter: "{b} ({c})",
                        },
                        xAxis: [
                            {
                                gridIndex: 0,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true
                                },
                                splitLine: {
                                    show: false
                                },
                                axisLine: {
                                    show: false
                                },
                            },
                        ],
                        yAxis: [
                            {
                                gridIndex: 0,
                                interval: 0,
                                data: yAxisData,
                                axisTick: {
                                    show: true,
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: "#35434C",
                                        fontSize: 12
                                    },
                                    formatter: function (yAxisData) {
                                        var strs = yAxisData.split(''); //字符串数组
                                        var str = ''
                                        for (var i = 0, s; s = strs[i++];) { //遍历字符串数组
                                            str += s;
                                            if (!(i % 12)) str += '\n'; //按需要求余
                                        }
                                        return str
                                    }
                                },
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#6E7079",
                                    },
                                },

                            },
                        ],
                        series: [
                            {
                                name: "销售金额",
                                type: "bar",
                                xAxisIndex: 0,
                                barWidth: "12",
                                barGap: 0,
                                itemStyle: {
                                    barBorderRadius: 0,
                                    color: '#085AFF',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#5087EC",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.chartData.saleRegionX,
                            },
                            {
                                name: "消费金额",
                                type: "bar",
                                xAxisIndex: 0,
                                barWidth: "12",
                                barGap: 0,
                                itemStyle: {
                                    barBorderRadius: 0,
                                    color: '#2FD0D5',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#68BBC4",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.chartData.netRegionX,
                            },
                        ],
                    };
                    myEcharts.setOption(options);


                });
            },
            //柱状图-门店
            async initStoreChart() {
                const _this = this
                this.getStoreData().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    var yAxisData = this.storeData.regionY;
                    let myEcharts = this.$echarts.init(this.$refs.storechart);
                    window.onresize = myEcharts.resize;
                    let options = {
                        grid: {
                            top: "15",
                            left: "15",
                            bottom: "50",
                            right: "7%",
                            containLabel: true,
                        },
                        legend: [
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#085AFF', fontSize: '14' },
                                data: [{ name: '销售金额', }],   //rect为矩形
                                bottom: '1%',
                                right: '56%'
                            },
                            {
                                itemWidth: 25,
                                itemHeight: 15,
                                textStyle: { color: '#2FD0D5', fontSize: '14' },
                                data: [{ name: '消费金额', }],   //rect为矩形
                                bottom: '1%',
                                right: '25%',
                            },

                        ],
                        tooltip: {
                            borderColor: 'transparent',
                            formatter: "{b} ({c})",
                        },
                        xAxis: [
                            {
                                gridIndex: 0,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true
                                },
                                splitLine: {
                                    show: false
                                },
                                axisLine: {
                                    show: false
                                },
                            },
                        ],
                        yAxis: [
                            {
                                gridIndex: 0,
                                interval: 0,
                                data: yAxisData,
                                axisTick: {
                                    show: true,
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: "#35434C",
                                        fontSize: 12
                                    },
                                    formatter: function (yAxisData) {
                                        var strs = yAxisData.split(''); //字符串数组
                                        var str = ''
                                        for (var i = 0, s; s = strs[i++];) { //遍历字符串数组
                                            str += s;
                                            if (!(i % 12)) str += '\n'; //按需要求余
                                        }
                                        return str
                                    }
                                },
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#6E7079",
                                    },
                                },

                            },
                        ],
                        series: [
                            {
                                name: "销售金额",
                                type: "bar",
                                xAxisIndex: 0,
                                barWidth: "12",
                                barGap: 0,
                                itemStyle: {
                                    barBorderRadius: 0,
                                    color: '#085AFF',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#5087EC",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.storeData.saleRegionX,
                            },
                            {
                                name: "消费金额",
                                type: "bar",
                                xAxisIndex: 0,
                                barWidth: "12",
                                barGap: 0,
                                itemStyle: {
                                    barBorderRadius: 0,
                                    color: '#2FD0D5',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#68BBC4",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.storeData.netRegionX,
                            },
                        ],
                    };
                    myEcharts.setOption(options);

                    let H = 0
                    if (this.checkedStore.id == 0) {
                        H = 300
                    } else {
                        H = options.yAxis[0].data.length * 35
                    }
                    //将该echarts用之前配置好的option的配置项进行渲染
                    var autoHeight = options.xAxis.length * 60 + H
                    //获取option配置项中数据源的长度*每个柱状你想设定的高度+150的预留高度
                    myEcharts.getDom().style.height = autoHeight + "px"
                    //echarts有个getDom（）的方法可以设置获取 ECharts 实例容器的 dom 节点，给节点分别设置高度
                    myEcharts.getDom().childNodes[0].style.height = autoHeight + "px"
                    // myEcharts.getDom().childNodes[0].childNodes[0].setAttribute("height", autoHeight)
                    myEcharts.getDom().childNodes[0].childNodes[0].style.height = autoHeight + "px"
                    //根据窗口的大小变动图表
                    myEcharts.resize()

                    // 跳转
                    myEcharts.on('click', params => { // 柱形图点击事件
                        console.log(params);
                    })


                });

            },
            // 列表数据
            getCustList() {
                request({
                    url: `/business/nurseItemsDetails?page=${this.page}&searchStr=${this.searchStr}&date=${this.$route.query.date}&type=${this.$route.query.type}`,
                    method: "get",
                })
                    .then((res) => {
                        this.customerList = this.page == 1 ? res.data.list : this.customerList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                        // 手动清除 Toast
                        Toast.clear();
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        if (this.customerList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 区域分布数据
            getChartData() {
                return request({
                    url: `/business/projects/region?date=${this.$route.query.date}&type=${this.$route.query.type}&targetId=${this.$route.query.targetId}&id=${this.checkedRegion.id}`,
                    method: "get",
                })
                    .then((res) => {
                        this.chartData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 门店分布数据
            getStoreData() {
                if (!this.changeId) {
                    this.changeId = this.checkedRegion.id
                }
                return request({
                    url: `/business/projects/store?date=${this.$route.query.date}&type=${this.$route.query.type}&targetId=${this.$route.query.targetId}&id=${this.changeId}&storeId=${this.checkedStore.id}`,
                    method: "get",
                })
                    .then((res) => {
                        this.storeData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.refreshing = false;
                this.page = 1
                this.customerList = []
                this.getCustList()
            },
            // 查询
            onSearch(e) {
                this.searchStr = e
                this.onRefresh();
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh();
            },
            //跳转顾客详情页
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload();
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id != 0 && data.id != -1) {
                        this.$router.replace({
                            name: "emphasisNursing",
                            query: {
                                date: this.$route.query.date,
                                type: this.$route.query.type
                            }
                        });
                    }
                })
            },
        },
    };
</script>
<style lang="less" scoped>
    .manage-module {
        height: 100%;
        // padding: 30px 30px;
        padding-bottom: 13%;
        overflow-y: auto;

        .txt {
            font-size: 26px;
            color: #66757f;
        }

        .txt-line {
            // margin-top: 16px;
            padding-bottom: 30px;
            border-bottom: 1px solid #d7d7d7;
        }

        .unit {
            margin-top: 20px;
            font-size: 26px;
            color: #66757f;
            text-align: right;
        }

        #nursingchart {
            width: 100%;
            height: 449px;
        }

        #storechart {
            width: 100%;
            height: 449px;
        }

        .add-up-box {
            padding: 30px 70px 50px 70px;

            >.tit {
                width: 350px;
                font-size: 24px;
                color: #a0acb5;

                .num {
                    font-weight: 700;
                    color: #35434c;
                }
            }

            >.tit:nth-child(1) {
                margin-right: 50px;
            }
        }

        .list-box {
            width: 100%;
            justify-content: space-between;
            margin: 0 auto 0;
            position: relative;
            z-index: 1;
            padding: 0 0 250px 0;

            .customer-list {
                z-index: 35;
                min-height: 331px;
                border-radius: 30px;
                background-color: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
                width: 690px;
                position: relative;
                margin: 28px auto;

                .customer-list-box {
                    width: 632px;
                    min-height: 269px;
                    margin: 30px 0 30px 30px;
                }

                .customer-outer {
                    width: 630px;
                    min-height: 212px;
                    margin-left: 2px;

                    .customer-group {
                        width: 325px;
                    }

                    .customer-info {
                        width: 320px;
                        height: 88px;
                    }

                    .head-portrait {
                        width: 88px;
                        height: 88px;
                        border-radius: 45px;
                    }

                    .customer-info-box {
                        width: 212px;
                        height: 88px;
                        margin-left: 30px;
                    }

                    .customer-main {
                        width: 400px;
                        height: 48px;
                    }

                    .name {
                        max-width: 260px;
                        height: 48px;
                        display: inline-block;
                        color: rgba(53, 67, 76, 1);
                        font-size: 34px;
                        line-height: 48px;
                        text-align: left;
                        overflow: hidden;
                        /*溢出的部分隐藏*/
                        white-space: nowrap;
                        /*文本不换行*/
                        text-overflow: ellipsis;
                        /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
                    }

                    .card-grade {
                        height: 34px;
                        border-radius: 17px;
                        margin-top: 6px;
                        margin-left: 20px;
                    }

                    .txt3 {
                        width: 66px;
                        height: 30px;
                        display: inline-block;
                        color: rgba(255, 255, 255, 1);
                        font-size: 22px;
                        white-space: nowrap;
                        line-height: 30px;
                        text-align: left;
                        margin: 2px 0 0 12px;
                    }

                    .card-image {
                        height: 34px;
                        width: 90px;
                    }

                    .mobile {
                        width: 147px;
                        height: 37px;
                        display: inline-block;
                        color: rgba(53, 67, 76, 1);
                        font-size: 26px;
                        white-space: nowrap;
                        line-height: 37px;
                        text-align: left;
                        margin-top: 6px;
                    }

                    .membership-box {
                        width: 325px;
                        height: 37px;
                        margin-top: 30px;
                    }

                    .membership-attributes {
                        width: 234px;
                        height: 37px;
                        display: inline-block;
                        color: rgba(121, 138, 148, 1);
                        font-size: 26px;
                        white-space: nowrap;
                        line-height: 37px;
                        text-align: left;
                    }

                    .membership-div {
                        padding: 0 5px;
                        margin-left: 30px;
                        width: 70px;
                        height: 34px;
                        border-radius: 23px;
                        border: 2px solid #2fd0d5;
                        color: rgba(47, 208, 213, 1);
                        font-size: 22px;
                        white-space: nowrap;
                        line-height: 34px;
                        text-align: center;
                    }

                    .card-balance {
                        width: 234px;
                        height: 37px;
                        display: inline-block;
                        color: rgba(121, 138, 148, 1);
                        font-size: 26px;
                        white-space: nowrap;
                        line-height: 37px;
                        text-align: left;
                        margin-top: 20px;
                    }
                }

                .arrived-store {
                    width: 579px;
                    height: 37px;
                    display: inline-block;
                    color: rgba(121, 138, 148, 1);
                    font-size: 26px;
                    white-space: nowrap;
                    line-height: 37px;
                    text-align: left;
                    margin-top: 20px;
                }
            }
        }
    }

    .box {
        padding: 0 30px;
    }

    .box.pb-50 {
        padding-bottom: 50px;
    }

    .box.pt-50 {
        padding-top: 50px;
    }

    .store-box {
        padding: 30px 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    .cut-line {
        width: 100%;
        height: 20px;
        background: #f8f8fa;
    }

    .empty-box {
        background-color: #fff;
        padding-top: 50px;
        padding-bottom: 50px;

        .empty-icon {
            width: 210px;
            height: 210px;
        }

        .empty-txt {
            font-size: 28px;
            color: #a0acb5;
        }
    }

    :deep(.search .van-search) {
        background-color: #fff !important;
        padding: 0 0 0 0 !important;
    }

    :deep(.search .van-icon) {
        font-size: 28px;
    }

    :deep(.search .van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 8px 20px 0 20px !important;
        margin-right: 0 !important;
    }
</style>